import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Divider, Box } from '@mui/material';
import { useAppSelector } from 'src/store';
import { useTranslation } from 'react-i18next';

const ParentCard = ({
  title,
  subheader,
  children,
  sx,
  cardContentSx,
  footer = null,
  codeModel = <></>
}) => {
  const customizer = useAppSelector((state) => state.customizer);
  const { t } = useTranslation();
  return (
    <Card
      sx={{ padding: 0, ...sx }}
      elevation={customizer.isCardShadow ? 9 : 0}
      variant={!customizer.isCardShadow ? 'outlined' : undefined}>
      <CardHeader
        title={typeof title === 'string' ? t(title) : title}
        subheader={subheader}
        action={codeModel}
      />
      <Divider />

      <CardContent sx={cardContentSx}>{children}</CardContent>
      {footer ? (
        <>
          <Divider />
          <Box>{footer}</Box>
        </>
      ) : undefined}
    </Card>
  );
};

ParentCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  codeModel: PropTypes.node,
  footer: PropTypes.node
};

export default ParentCard;
